import BaseModel from './BaseModel'

export default class QuestionModel extends BaseModel {
    get schema() {
        return {
            id: ['id', undefined, value => value],
            name: ['name', undefined, value => value],
            type: ['type', undefined, value => value],
            bonus: ['bonus', undefined, value => parseInt(value)],
            order: ['order', undefined, value => parseInt(value)],
            maxScore: ['maxScore', undefined, value => parseInt(value)],
            dateL: ['dateL', undefined, value => parseInt(value)],
            dateR: ['dateR', undefined, value => parseInt(value)],
        }
    };

    static attributeLabels = {
        id: 'ID',
        name: 'Название',
    }
}
